import React, { FC, PropsWithChildren, ReactNode, useState } from 'react'

import { IconChevronDown, IconChevronUp } from '@avantstay/backoffice-vectors'

import * as S from './Collapsible.styles'

interface CollapsibleProps {
  title?: ReactNode
  titleDirection?: string
  defaultCollapsed?: boolean
}

const Collapsible: FC<PropsWithChildren<CollapsibleProps>> = ({
  title,
  titleDirection,
  children,
  defaultCollapsed = true,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed)

  return (
    <S.Container>
      <S.Title onClick={() => setIsCollapsed(!isCollapsed)} $titleDirection={titleDirection}>
        {isCollapsed ? <IconChevronUp /> : <IconChevronDown />}
        {title}
      </S.Title>
      {isCollapsed && children}
    </S.Container>
  )
}

export { Collapsible }
